import React from 'react';
import { localize } from 'core/localization';
import { FormTitle, CommentFormContainer, CommentTextarea } from './CommentForm.styled';
import { REVIEW_COMMENT_PROPERTIES, REVIEW_COMMENT_TYPES } from 'constants/review';

type CommentFormProps = {
  commentText: string;
  isValidComment: boolean;
  onChange(e?: any): void;
  getRefs(e?: any): void;
  context: any;
  isGeneral: boolean;
};

export const localizationKeys: { [key: string]: string } = {
  [REVIEW_COMMENT_PROPERTIES.DEFAULT_TITLE]: 'your comment',
  [REVIEW_COMMENT_PROPERTIES.TITLE]: 'course comment',
  [REVIEW_COMMENT_PROPERTIES.INTRODUCTION]: 'introduction comment',
  [REVIEW_COMMENT_PROPERTIES.LEARNING_CONTENT]: 'learning content comment',
  [REVIEW_COMMENT_PROPERTIES.QUESTION]: 'question comment',
  [REVIEW_COMMENT_PROPERTIES.VOICE_OVER]: 'voice over comment',
  [REVIEW_COMMENT_PROPERTIES.CONTENT_ITEM]: 'content item comment',
  [REVIEW_COMMENT_PROPERTIES.TITLE_OF_THE_SECTION]: 'section comment',
  [REVIEW_COMMENT_PROPERTIES.GENERAL]: 'leave general comments'
};

function getLocalizationKey({ type, property = '', isGeneral }: { type: string; property: string; isGeneral: boolean }): string {
  if (isGeneral) {
    return localizationKeys[REVIEW_COMMENT_PROPERTIES.GENERAL];
  }
  switch (type) {
    case REVIEW_COMMENT_TYPES.QUESTION:
      return localizationKeys[property] || localizationKeys[REVIEW_COMMENT_PROPERTIES.QUESTION];
    case REVIEW_COMMENT_TYPES.INFORMATION_CONTENT:
      return localizationKeys[property] || localizationKeys[REVIEW_COMMENT_PROPERTIES.CONTENT_ITEM];
    case REVIEW_COMMENT_TYPES.COURSE:
      return localizationKeys[property];
    case REVIEW_COMMENT_TYPES.SECTION:
      return localizationKeys[REVIEW_COMMENT_PROPERTIES.TITLE_OF_THE_SECTION];
    default:
      return localizationKeys[REVIEW_COMMENT_PROPERTIES.DEFAULT_TITLE];
  }
}

export const CommentForm = (props: CommentFormProps) => {
  const { commentText, isValidComment, onChange, getRefs, context, isGeneral } = props;
  const type = context && context.type;
  const property = context && context.property;
  const title = getLocalizationKey({ type, property, isGeneral });

  return (
    <CommentFormContainer>
      <FormTitle>{localize(`[${title}]`)}</FormTitle>
      <CommentTextarea
        tabIndex={1}
        ref={getRefs}
        ariaLabel={localize('[comment area]')}
        validComment={isValidComment}
        onChange={onChange}
        name="commentText"
        value={commentText}
      />
    </CommentFormContainer>
  );
};

export default CommentForm;
